import { FC, memo, useState } from 'react'
import { Button } from '@chakra-ui/react'

import { Document } from 'components/icons'
import getPrivateFile from 'services/calls/file/getPrivateFile'
import { openFile } from 'utils/files'
import { CustomGetFileURL } from 'DigitalArchive/components/FileDetails'

type Props = {
  customGetFileURL?: CustomGetFileURL
  fileId?: string
  fileSlug?: string
  children: string
}

const OpenFileButton: FC<Props> = ({ customGetFileURL, children, fileId, fileSlug }) => {
  const [loadingFile, setLoadingFile] = useState<boolean>(false)

  const handleOpenFile = async () => {
    setLoadingFile(true)
    let response
    if (customGetFileURL) {
      response = await customGetFileURL({ fileId, fileSlug })
    } else {
      response = await getPrivateFile({ fileId, fileSlug })
    }
    if (response?.header?.success) {
      const fileURL = response?.body?.file?.url
      openFile(fileURL)
    }
    setLoadingFile(false)
  }

  return (
    <Button isLoading={loadingFile} minWidth="100%" variant="outline" leftIcon={<Document />} onClick={handleOpenFile}>
      {children}
    </Button>
  )
}

export default memo(OpenFileButton)
